'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/9/3.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _background = require('redux/modules/background');

var _reactRouterRedux = require('react-router-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailPage = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: state.background.isLoading,
    toLogin: state.background.toLogin,
    loginValid: state.auth.loginValid,
    loginErrorMsg: state.auth.loginErrorMsg
  };
}, (0, _extends3.default)({}, authActions, {
  routerPush: _reactRouterRedux.push,
  routerReplace: _reactRouterRedux.replace,
  hideLogoutModal: _background.changeToLoginFalse
})), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DetailPage, _Component);

  function DetailPage() {
    (0, _classCallCheck3.default)(this, DetailPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DetailPage).call(this));

    _this.state = {
      isLoginModalOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(DetailPage, [{
    key: 'onLogin',
    value: function onLogin(data) {
      var _this2 = this;

      var _props = this.props;
      var login = _props.login;
      var hideLogoutModal = _props.hideLogoutModal;

      if (login && hideLogoutModal) {
        login(data).then(function (nextData) {
          if (nextData.isValid) {
            hideLogoutModal();
            _this2.setState({
              isLoginModalOpened: false
            });
          } else {
            _this2.setState({
              isLoginModalOpened: true
            });
          }
        });
      }
    }
  }, {
    key: 'onLoginClose',
    value: function onLoginClose() {
      var hideLogoutModal = this.props.hideLogoutModal;

      if (hideLogoutModal) {
        hideLogoutModal();
        this.setState({
          isLoginModalOpened: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var isLoading = _props2.isLoading;
      var toLogin = _props2.toLogin;
      var loginValid = _props2.loginValid;
      var loginErrorMsg = _props2.loginErrorMsg;
      var isLoginModalOpened = this.state.isLoginModalOpened;

      return _react2.default.createElement(
        'div',
        { style: { minWidth: 1280 } },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        this.props.children,
        _react2.default.createElement(_components.LoadModal, { isOpened: isLoading }),
        _react2.default.createElement(_components.LoginModal, { isOpened: toLogin || isLoginModalOpened, onSubmit: this.onLogin.bind(this),
          closeModalFunc: this.onLoginClose.bind(this), loginValid: loginValid,
          loginErrorMsg: loginErrorMsg,
          registerUrl: '/register', forgetPwdUrl: '/forgetPassword' })
      );
    }
  }]);
  return DetailPage;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  children: _react.PropTypes.object.isRequired,
  isLoading: _react.PropTypes.bool,
  toLogin: _react.PropTypes.bool,
  routerPush: _react.PropTypes.func,
  routerReplace: _react.PropTypes.func,
  hideLogoutModal: _react.PropTypes.func,
  login: _react.PropTypes.func,
  loginValid: _react.PropTypes.bool,
  loginErrorMsg: _react.PropTypes.string
}, _temp)) || _class);
exports.default = DetailPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/DetailPage/DetailPage.js
 ** module id = 1463
 ** module chunks = 0
 **/